import { createRequestTypes } from 'common/websocket-redux';

export const SET_USER_QLE_ENROLLMENT = createRequestTypes(
  'service/SET_USER_QLE_ENROLLMENT',
);
export const REQUEST_USER_INITIATE_QLE_REENROLLMENT =
  'employee/REQUEST_USER_INITIATE_QLE_REENROLLMENT';
